<template>
  <div id='goodsdetail'>
         <NavTop title="商品详情"></NavTop>   
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for='item in goodsslide' :key='item.id'>
                  <van-image :src="item.img"/>
              </van-swipe-item>
        </van-swipe>

        <div class='goodspanel'>
            <div class='title'>{{goodsinfo.name}}</div>
            <div class='subtitle'>{{goodsinfo.desc}}</div>
            <div class='priceline'>
                <div class='mainprice'>¥{{goodsinfo.nowprice}}</div>
                <div class='dashprice'>¥{{goodsinfo.dashprice}}</div>         
            </div>
        </div>  
         <div class='goodspanel'>
            <div class='title'>商品详情</div>
            <div class='goodscontent'>
               <img v-for="(img,index) in goodscontent" v-lazy="img" class='gimg' :key='index'/>
            </div>
        </div>    
        <van-submit-bar :price="goodsinfo.price*100" button-text="提交订单" @submit="onSubmit" />
  </div>
</template>
<script>
import { NavBar,Icon , Swipe, SwipeItem,Button,Dialog,Image as VanImage ,SubmitBar } from 'vant';
import NavTop from '@/components/navtop'

export default {
   name: 'index',
   data() {
      return {
           goodsslide:[],
           goodsinfo:{},
           goodscontent:[]
      }
   }, 
   created(){
        this.$store.commit('INIT_CART')
        this.$store.commit('INIT_ADDRESS')
        this.getList(); 
   },
   watch:{
      "$route"(){
          this.getList(); 
      }
   },
   methods: {
      getList(){
           let goodsid=this.$route.params.goodsid
           this.$post("/goods/getDGoodsDetail",{goodsid:goodsid}).then((data)=>{
               if(data.result.success){
                  this.goodsslide=data.result.info.slides
                  this.goodsinfo=data.result.info.goodsinfo
                  this.goodscontent=data.result.info.goodscontent
               }else{
                  this.$toast(data.result.info)
               }
           })
      },
      onSubmit(){
           this.$store.commit("SET_DGOODS",{goodsid:this.$route.params.goodsid})
           this.$go("/dorder")
      }
   },
   components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Button.name]: Button,
        [Dialog.Component.name]: Dialog.Component,
        [VanImage.name]:VanImage,
        [SubmitBar.name]:SubmitBar,
        NavTop
   }
}
</script>
<style scoped>
#goodsdetail{background-color:#F6F6F6;min-height: 100vh;}
::v-deep .van-search{position:fixed;width:100%;top:0;left:0;}
::v-deep .van-field__right-icon{display:flex;}
::v-deep [class*=van-hairline]::after{border: none;}
.my-swipe .van-swipe-item {color: #fff;max-height: 6rem;text-align: center;}
.goodspanel{text-align: left;padding: 0.2rem;background-color: #ffffff;border-radius: 0.2rem;margin: 0.15rem;}
.title{text-align: left;font-size: 0.42rem;padding: 0.2rem;}
.subtitle{text-align: left;color:#bbbbbb;padding: 0 0.2rem;}
.priceline{display: flex;align-items: center;padding: 0.2rem;}
.label{flex:1;align-self: flex-start;color:#cccccc;}
.description{flex:4;}
.mainprice{font-size:0.6rem;color:#CB0930;}
.dashprice{font-size: 0.3rem;text-decoration: line-through;color:#cccccc;padding: 0.2rem;}
.btncart{margin-left:auto;}
.goodspromotion{display: flex;flex-wrap: wrap;padding-bottom: 85px;}
::v-deep .shopshowitem-container{flex:1 0 45%;}
::v-deep .shopshow-items{overflow: hidden;flex-wrap: wrap;}
::v-deep .shopshowImg{width:100%;height:100%;}
.cartgoodspanel{display: flex;flex-flow: column nowrap;}
.cartgoodstitlecon{display: flex;}
.cartgoodstitle{font-size:0.4rem;font-weight: 600p;}
.cartgoodsdelbtn{margin-left: auto;}
.gimg{display: block;}
</style>